import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app.module'
import auth from './modules/auth.module'
import alert from './modules/alert.module'
import snack from './modules/snack.module'

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    App: app,
    Auth: auth,
    Alert: alert,
    Snack: snack
  }

})
